import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { SlideDown } from "@src/components/SlideDown";
import { SourceAudioVolumeMeterField, SourceShowCursorField, SourceSwitchDeviceField, } from "@src/components/Studio/Sources/components/SourceFileds";
export const SourceSlideDown = () => {
    const { t } = useTranslation("studio");
    return (_jsx(SlideDown, { title: t("source"), isOpen: true, content: _jsxs(_Fragment, { children: [_jsx(SourceSwitchDeviceField, { showPreview: false }), _jsx(SourceShowCursorField, {}), _jsx(SourceAudioVolumeMeterField, {})] }) }));
};
